

document.addEventListener('DOMContentLoaded', () => {
  var heads = document.getElementsByClassName('js-anchor');
  if (heads) {
      var contents = '';
      for(var i = 0; i < heads.length; i++){
        contents += `<li class="grid__item p-index-list__item"><a href="#index${i}">${heads[i].textContent}</a></li>`;
      }
      document.querySelector('#tag-index').innerHTML += contents;
  }
});